<template>
  <div id="qrcode-management">
    <div class="panel__header">
      <div class="head-left flex flex1">
        <button class="qrcode_handle_btn" @click="createQrcode">
          <i class="el-icon-plus"></i>
          建码
        </button>
        <!--        <button class="qrcode_handle_btn">-->
        <!--          <i class="el-icon-folder"></i>-->
        <!--          导出-->
        <!--        </button>-->

        <!--        <button class="qrcode_handle_btn">-->
        <!--          <i class="el-icon-printer"></i>-->
        <!--          打印-->
        <!--        </button>-->
      </div>

      <div class="head-right flex flex1 justify-end">
        <div class="qrcode_input" style="width: 260px">
          <el-input
            v-model.trim="searchContent"
            placeholder="输入二维码名称"
            @keyup.enter.native="searchQrcode"
          >
          </el-input>
        </div>
        <span class="search-btn-box" @click="searchQrcode"
          ><i class="el-icon-search icon-style"></i
        ></span>
      </div>
    </div>

    <div class="qrcode-management-component panel__body">
      <div class="menu-list-component">
        <QrcodeTypeMenu></QrcodeTypeMenu>
      </div>
      <div class="tab-component">
        <QrcodeManageTable ref="searchChild"></QrcodeManageTable>
      </div>
    </div>
  </div>
</template>
<script>
import QrcodeManageTable from '@/components/qrcode-management/QrcodeManageTable.vue'
import QrcodeTypeMenu from '@/components/qrcode-management/QrcodeTypeMenu.vue'
import QRCodeMixin from '@/mixin/qrcode.editor'
// let _this = void 0
import { mapMutations, mapGetters, mapState } from 'vuex'

export default {
  name: 'QRCodeManagement',
  components: {
    QrcodeManageTable,
    QrcodeTypeMenu,
  },
  filters: {},
  directives: {},
  mixins: [QRCodeMixin],
  props: {},
  data() {
    return {
      searchContent: '',
    }
  },
  computed: {
    ...mapState('editor', {
      QRCodeType: state => state.QRCodeType,
    }),
  },
  watch: {
    QRCodeType() {
      this.searchContent = ''
    },
  },
  created() {
    // _this = this
  },
  mounted() {},
  destroy() {},
  methods: {
    ...mapMutations(['setRouter']),
    ...mapMutations('editor', ['setEditorStatus']),
    ...mapGetters('editor', ['getQrcodeType']),
    /*
     * 创建二维码
     * */
    createQrcode() {
      const type = this.getQrcodeType()
      if (!type) {
        this.$confirm('请添加二维码分类', '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning',
          confirmButtonClass: 'qrcode_modal_confirm_btn',
        })
        return
      }
      this.createQRCode()
      this.setEditorStatus('create')
    },
    /*
     * 模糊查询二维码
     * */
    searchQrcode() {
      this.$refs.searchChild.searchQrcodeByText(this.searchContent)
    },
  },
}
</script>
<style lang="scss" scoped>
#qrcode-management {
  width: 100%;
  overflow: auto;
  background: #ffffff;
  border-radius: 4px;
}

.head-left button {
  margin-right: 12px;
}
.head-left i {
  font-size: 14px;
}

.head-right {
  padding-right: 18px;
}

.search-inp {
  width: 260px;
  float: right;
}

.icon-style {
  font-size: 22px;
  color: #ffffff;
}
.qrcode-management-component {
  display: flex;
  padding-left: 4px;
}

.menu-list-component {
  width: 200px;
  float: left;
  text-align: center;
}

.tab-component {
  float: right;
  width: calc(100% - 200px);
}
</style>
<style lang="scss"></style>
